import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class Folder {

    private _folderId: string;
    private _templateId: string | null;
    private _name: string;
    private _createdDate: Date;
    private _changedDate: Date;

    public constructor(folderId: string, templateId: string | null, name: string, createdDate: Date, changedDate: Date) {

        this._folderId = folderId;
        this._templateId = templateId;
        this._name = name;
        this._createdDate = createdDate;
        this._changedDate = changedDate;
    }

    public get folderId(): string {
        return this._folderId;
    }

    public set folderId(value: string) {
        this._folderId = value;
    }

    public get templateId(): string | null {
        return this._templateId;
    }

    public set templateId(value: string | null) {
        this._templateId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get createdDate(): Date {
        return this._createdDate;
    }

    public set createdDate(value: Date) {
        this._createdDate = value;
    }

    public get changedDate(): Date {
        return this._changedDate;
    }

    public set changedDate(value: Date) {
        this._changedDate = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): Folder | null {

        const folderId: string | null = safeParseNullDefault<string>(object?._folderId, '');
        const templateId: string | null = safeParseNullDefault<string>(object?._templateId, '');
        const name: string = safeParse<string>(object?._name, '');
        const createdDate: Date | null = safeParseNullDefault<Date>(object?._createdDate, new Date());
        const changedDate: Date | null = safeParseNullDefault<Date>(object?._changedDate, new Date());

        if (folderId === null || createdDate === null || changedDate === null || folderId === '') {
            return null;
        }

        return new Folder(folderId, templateId, name, createdDate, changedDate);
    }
}

export default Folder;